// @ts-check
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { mapCCESItemToCardObject } from '@exchange-frontends/api/src/utils/ccesUtils';

import searchCcApps from '../actions/search-cc-apps';

/**
 * @param {import('@action-types/ccPublisher').UseCcPublisherAppsOptions} [options]
 * @param {{publisherId: string}} [overrides]
 */
const useCcPublisherApps = (options, overrides) => {
  const { id } = useParams();
  const publisherId = overrides?.publisherId || id;
  const { enabled = true, pageIndex = 0, pageSize = 24, ...queryOptions } = options ?? {};

  /** @type {import('@action-types/ccApps').CcAppsSearchPayload} */
  const payload = {
    filters: {
      ownerIds: [publisherId],
    },
    pageIndex,
    pageSize,
  };

  const data = useQuery({
    ...queryOptions,
    queryKey: ['get-publisher-apps-cc', publisherId, pageIndex, pageSize],
    enabled: Boolean(publisherId && enabled),
    queryFn: async ({ signal }) => {
      const response = await searchCcApps({
        signal,
        payload,
      });

      if (!response || !response.jsonResponse) {
        return null;
      }

      const { jsonResponse } = response;
      return {
        cloudApps: jsonResponse.items.map(mapCCESItemToCardObject),
        totalCount: jsonResponse.totalSize,
        pageIndex: jsonResponse.pageIndex,
        pageSize: jsonResponse.pageSize,
        totalPages: Math.ceil(jsonResponse.totalSize / jsonResponse.pageSize),
      };
    },
  });

  return data;
};

export default useCcPublisherApps;
